import { Routes } from '@angular/router';
import { authGuard } from './auth.gaurd';
import { embedGuard } from './embed.guard';
import { MainLayoutComponent } from './components/shared/main-layout/main-layout.component';
import { LoginComponent } from './components/pages/public/login/login.component';
import { NewPasswordComponent } from './components/pages/public/new-password/new-password.component';
import { ContractDetailsComponent } from './components/pages/public/contract-details/contract-details.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
// import { SupportChatComponent } from './components/pages/support-chat/support-chat.component';
import { SearchComponent } from './components/shared/main-layout/search/search.component';
import { InvalidComponent } from './components/pages/public/invalid/invalid.component';
import { ExportBtnComponent } from './export-btn/export-btn.component';
import { NotificationsComponent } from './components/shared/notifications/notifications.component';
import { SearchDetailsComponent } from './components/shared/main-layout/search-details/search-details.component';
import { SetDndComponent } from './components/shared/main-layout/set-dnd/set-dnd.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';

export const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  {
    path: 'app',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard', component: DashboardComponent
      },
      // done
      {
        path: 'assignments',
        loadChildren: () => import('./components/pages/assignments/assignments.module').then(m => m.AssignmentsModule),
      },
      // done
      {
        path: 'business',
        loadChildren: () => import('./components/pages/business/business.module').then(m => m.BusinessModule),
      },
      // done
      {
        path: 'leads',
        loadChildren: () => import('./components/pages/leads/leads.module').then(m => m.LeadsModule),
      },
       // done
      {
        path: 'training',
        loadChildren: () => import('./components/pages/training/training.module').then(m => m.TrainingModule),
      },
      // done
      {
        path: 'internal-tickets',
        loadChildren:() =>  import('./components/pages/internal-ticket/internal-ticket.module').then(m => m.InternalTicketModule),
      },

      // done
      {
        path: 'debt-recovery',
        loadChildren: () => import('./components/pages/debt-recovery/debt-recovery.module').then(m => m.DebtRecoveryModule),
      },
      // done
      {
        path: 'paid-in-full',
        loadChildren: () => import('./components/pages/debt-recovery/debt-recovery.module').then(m => m.DebtRecoveryModule),
      },
      // done
      {
        path: 'customers',
        loadChildren: () => import('./components/pages/customers/customers.module').then(m => m.CustomersModule),
      },

      // done
      {
        path: 'contracts',
        loadChildren:() =>  import('./components/pages/contracts/contracts.module').then(m => m.ContractsModule),
      },
      // done
      {
        path: 'users',
        loadChildren:() =>  import('./components/pages/users/users.module').then(m => m.UsersModule),
      },
      // done
      {
        path: 'admin-settings',
        loadChildren: () => import('./components/pages/admin-settings/admin-settings.module').then((m) => m.AdminSettingModule),
      },
      {
        path: 'settings',
        loadChildren:() =>  import('./components/pages/settings/settings.module').then(m => m.SettingsModule),
      },
      {
        path: 'bsa',
        loadChildren:() =>  import('./components/pages/bsa/bsa.module').then(m => m.BsaModule),
      },
      {
        path: 'call-recordings',
        loadChildren: () => import('./components/pages/call-recordings/call-recordings.module').then(m => m.CallRecordingsModule),
      },
      {
        path: 'communication',
        loadChildren:() =>  import('./components/pages/export-agent-calls/export-agent-calls.module').then(m => m.ExportAgentCallsModule),
      },
      // done
      {
        path: 'payments',
        loadChildren:() =>  import('./components/pages/payments/payments.module').then(m => m.PaymentsModule),
      },
      {
        path: 'chatsupport',
        loadChildren:() => import('./components/pages/support-chat/support-chat.module').then(m => m.SupportChatModule)
      },
      {
        path: 'utm-parameters',
        loadChildren:() => import('./components/pages/utmparameters/utmparameter.module').then(m => m.UtmparameterModule)
      },
      {
        path: 'home',
        loadChildren:() => import('./components/pages/home/home.module').then(m => m.HomeModule)
      },{
        path:'m2r-reports',
        loadChildren:()=> import('./components/pages/m2r-report/m2rReport.module').then(m=>m.m2rReportModule)
      },
      {
        path: 'errors',
        loadChildren:() => import('./components/pages/errors/errors.module').then(m => m.ErrorsModule)
      },
      { path: 'dnd-profile', component: SetDndComponent },
      {
        path: 'search', component: SearchComponent
      },
      {
        path: 'home',
        loadChildren:() => import('./components/pages/home/home.module').then(m => m.HomeModule)
      },
      { path: '404', component: InvalidComponent },
      {
        path: 'notifications',
        component: NotificationsComponent
      },
      {
        path: 'notifications/:id',
        component: NotificationsComponent
      }, 
      {   
        path: 'details-search', component: SearchDetailsComponent
      },
      {
        path: 'engagement-activity-stats',
        loadChildren: () => import('./components/pages/engagement-activity-stats/engagement-activity-stats.module').then(m => m.EngagementActivityStatsModule)
      },
      {
        path: 'compliance-legal',
        loadChildren:() => import('./components/pages/compliance-legal/compliance-legal.module').then(m=>m.ComplianceLegalModule)
      },
      {
        path: 'license-management',
        loadChildren:() => import('./components/pages/license-management/license-management.module').then(m=>m.LicenseManagementModule)
      },
      {
          path: 'email-blasting-panel',
          loadChildren: () => import('./components/pages/email-blasting/email-blasting.module').then(m => m.EmailBlastingModule),
      },
      { path: '404', component: NotFoundComponent },
      { path: '**', component: NotFoundComponent },
    ],
  },
  // Bare, read-only dashboard for other products to embed in an iframe. Outside MainLayout
  // and authGuard on purpose: it authenticates with the token in the URL fragment instead.
  { path: 'embed/dashboard', component: DashboardComponent, canActivate: [embedGuard] },
  { path: 'login', component: LoginComponent },
  // { path: 'contract-details', component: ContractDetailsComponent },
  // { path: 'export', component: ExportBtnComponent },
  { path: 'new-password', component: NewPasswordComponent },
  { path: 'export', component: ExportBtnComponent },
  { path: '**', redirectTo: 'app/404' },
];
